import * as Types from './types'

export const FETCH_REFERENCE_DATA = 'FETCH_REFERENCE_DATA'
export const SERVER_RESOURCE = '/reference'

export const SUBSCRIPTION_TYPES: Types.ReferenceData[] = [
  {
    description: 'Regular Content',
    id: 1,
    name: 'Content',
  },
  {
    description: 'Lead Stories',
    id: 4,
    name: 'Lead',
  },
  {
    description: 'Preferred Content',
    id: 5,
    name: 'Preferred',
  },
  {
    description: 'Sponsored Content',
    id: 6,
    name: 'Sponsored',
  },
]
export const DEFAULT_SUBSCRIPTION_TYPE: Types.ReferenceData = SUBSCRIPTION_TYPES[0]

export const SUBSCRIPTION_CATEGORIES: Types.ReferenceData[] = [
  {
    description: 'News Articles',
    id: 1,
    name: 'Content',
  },
  {
    description: 'Job postings',
    id: 2,
    name: 'Job',
  },
  {
    description: 'Event postings',
    id: 3,
    name: 'Event',
  },
  {
    description: 'Webinar postings',
    id: 4,
    name: 'Webinar',
  },
  {
    description: 'Native content',
    id: 7,
    name: 'Native',
  },
]

export const PROMOTION_CATEGORIES: Types.ReferenceData[] = [
  {
    description: 'Advertising',
    id: 1,
    name: 'Content',
  },
  {
    description: 'Market Surveys',
    id: 5,
    name: 'Surveys',
  },
]
export const DEFAULT_SUBSCRIPTION_CATEGORY: Types.ReferenceData = SUBSCRIPTION_CATEGORIES[0]

export const CONTENT_CATEGORY = 'Content'

export const RSS_FEED = 'RSS Feed'
export const TWITTER_FEED = 'Twitter'
export const MANUAL_ENTRY_FEED = 'Manual Entry'
export const SOURCE_TYPES: Types.ReferenceData[] = [
  {
    description: 'RSS Feed',
    id: 1,
    name: RSS_FEED,
  },
  {
    description: 'Twitter Feed',
    id: 4,
    name: TWITTER_FEED,
  },
]
export const DEFAULT_SOURCE_TYPE: Types.ReferenceData = SOURCE_TYPES[0]

export const emptyState: Types.ReferenceState = {
  templates: [],
}



// WEBPACK FOOTER //
// ./src/pages/reference/constants.ts